import { render, staticRenderFns } from "./Atlas_Desktop.vue?vue&type=template&id=06c136a5&scoped=true&"
import script from "./Atlas_Desktop.vue?vue&type=script&lang=js&"
export * from "./Atlas_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Atlas_Desktop.vue?vue&type=style&index=0&id=06c136a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c136a5",
  null
  
)

export default component.exports